<template>
  <div id="container" class="xer-l-application xer-l-application--navbar">
    <!-- TODO: include actual header here and provide slot for header content -->
    <slot name="header" />
    <main
      class="xer-l-application__main xer-t-application-main xer-t-application-main--navbar xer-t-application-main--footer xer-card xer-card--xxl xer-pt-1 tablet:xer-pt-7"
    >
      <div
        class="xer-h-full xer-flex xer-flex-col xer-content-center xer-justify-between tablet:xer-justify-center"
      >
        <slot v-if="rootStore.rootDataLoaded" />
        <xer-loading v-else />
      </div>
      <slot v-if="!hideNavbar" name="navbar" />
    </main>
    <footer class="xer-l-application__footer">
      <slot name="footer" />
    </footer>
    <div v-if="!hideNavbar" class="xer-l-application__navbar"></div>
  </div>
</template>
<script>
import XerLoading from '@/components/XerLoading';
import { mapStores } from 'pinia';
import { useRootStore } from '@/stores';

export default {
  components: {
    XerLoading
  },
  props: {
    hideNavbar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapStores(useRootStore)
  }
};
</script>
